import { render } from "./AdmissionSource.vue?vue&type=template&id=b22c2838&ts=true"
import script from "./AdmissionSource.ts?vue&type=script&lang=ts&external"
export * from "./AdmissionSource.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__